<template>
	<div class="tool-component">
		<div class="tools">
			<div v-show="showTop" class="tool-item top" @click="scrollToTop()">
				<svg-icon name="top" />
				<svg-icon name="top2" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Tool',
	data() {
		return {
			showTop: false,
		};
	},
	mounted() {
		// 监听页面滚动，显示返回顶部
		const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		const scrollThreshold = viewportHeight * 1.2;
		window.addEventListener('scroll', () => {
			// console.log('垂直滚动位置:', window.scrollY);
			if (window.scrollY > scrollThreshold) {
				this.showTop = true
			} else {
				this.showTop = false
			}
		});
	},
	methods: {
		scrollToTop() {
			this.$bus.$emit('backTop', { behavior: 'smooth' });
		},
	}
};
</script>

<style lang="scss" scoped>
.app-component .tool-item {
	&.top {
		
	}
}
.tool-component {
	.tools {
		position: fixed;
		z-index: 999;
		// right: 10px;
		left: calc(100% - 37px);
		bottom: calc($foot-height + 35px);
		display: flex;
		flex-direction: column;
		.tool-item.top {
			width: 37px;
			height: 37px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			&:hover {
				.svg-top {
					display: none;
				}
				.svg-top2 {
					display: block;
				}
			}
			.svg-top {
				width: 37px;
				height: 37px;
			}
			.svg-top2 {
				display: none;
				width: 37px;
				height: 37px;
			}
		}
	}
}
</style>
